module.exports = __webpack_public_path__ + "fonts/Inter-800-latin77.260c81a.woff2";